import React, { useState, useEffect } from 'react'
import Table from '../../../components/UI/table'
import cloverAPI from '../../../utils/cloverAPI'
import Loader from '../../../components/Loader'
import Form from 'react-bootstrap/Form'
import formatPrice from '../../../utils/formatCloverPrice'
import backendAPI from '../../../utils/backendAPI'
import Button from 'react-bootstrap/Button'

function Analytics() {
	const [cloverItemsList, setCloverItemsList] = useState([])
	const [loading, setLoading] = useState(false)
	const [dateRange, setDateRange] = useState('thisMonth')

	const LIMIT = 1000

	const getDateFilter = () => {
		const now = new Date()
		let date = new Date()
		switch (dateRange) {
			case 'last2Months':
				date.setMonth(now.getMonth() - 2)
				break
			case 'last3Months':
				date.setMonth(now.getMonth() - 3)
				break
			case 'thisMonth':
			default:
				date.setMonth(now.getMonth() - 1)
				break
		}
		return date.getTime()
	}

	useEffect(() => {
		const fetchCloverItems = async () => {
			setLoading(true)

			try {
				const queryParams = new URLSearchParams({
					limit: LIMIT,
					expand: 'lineItems',
					filter: `createdTime>${getDateFilter()}`,
				})

				const res = await cloverAPI.get(`/orders/?${queryParams.toString()}`)

				if (res.status === 200) {
					const itemsMap = new Map()

					res.data.elements.forEach((order) => {
						order.lineItems.elements.forEach((item) => {
							if (itemsMap.has(item.name)) {
								const existingItem = itemsMap.get(item.name)
								existingItem.frequency += 1
								existingItem.totalSales += item.price
							} else {
								itemsMap.set(item.name, {
									id: item.id,
									name: item.name,
									price: item.price,
									frequency: 1,
									totalSales: item.price,
								})
							}
						})
					})

					const sortedItems = Array.from(itemsMap.values()).sort(
						(a, b) => b.totalSales - a.totalSales
					)
					setCloverItemsList(sortedItems)
				}
			} catch (e) {
				console.log('Error Fetching Items:', e)
				setCloverItemsList([])
			} finally {
				setLoading(false)
			}
		}

		fetchCloverItems()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dateRange])

	const [customerData, setCustomerData] = useState([])
	const [showHistory, setShowHistory] = useState({})

	useEffect(() => {
		const fetchCustomerData = async () => {
			setLoading(true)

			try {
				const res = await backendAPI.get(`/api/clover/customer-loyalty/`)
				if (res.status === 200) {
					console.log(res.data)
					setCustomerData(res.data)
				}
			} catch (e) {
				console.log('Error Fetching Data:', e)
				setCustomerData([])
			} finally {
				setLoading(false)
			}
		}

		fetchCustomerData()
	}, [])

	const toggleHistory = (customerId) => {
		setShowHistory((prevState) => ({
			...prevState,
			[customerId]: !prevState[customerId],
		}))
	}

	return (
		<div className="content-page">
			<div className="content">
				<div className="container-fluid">
					<br />
					<div className="page-title-and-bnt">
						<h1>Analytics</h1>
					</div>
					<br />

					{/* Filter & Expand Options */}
					<Form className="d-flex align-items-center mb-3">
						<Form.Group controlId="dateRange" className="ml-3">
							<Form.Label>Date Range</Form.Label>
							<Form.Control
								as="select"
								value={dateRange}
								onChange={(e) => setDateRange(e.target.value)}
							>
								<option value="thisMonth">This Month</option>
								<option value="last2Months">Last 2 Months</option>
								<option value="last3Months">Last 3 Months</option>
							</Form.Control>
						</Form.Group>
					</Form>
					{loading ? (
						<Loader />
					) : (
						<>
							<h4>Top Performing Products</h4>
							<Table variant="striped" stickyHeader>
								<thead>
									<tr>
										<th>ID</th>
										<th>Name</th>
										<th>Price</th>
										<th>Frequency</th>
										<th>Total Sales</th>
									</tr>
								</thead>
								<tbody>
									{cloverItemsList && cloverItemsList.length > 0 ? (
										cloverItemsList.map((item) => (
											<tr key={item.id}>
												<td>{item.id}</td>
												<td>{item.name}</td>
												<td>{formatPrice(item.price)}</td>
												<td>{item.frequency}</td>
												<td>{formatPrice(item.totalSales)}</td>
											</tr>
										))
									) : (
										<tr>
											<td colSpan="5" className="text-center">
												No items found
											</td>
										</tr>
									)}
								</tbody>
							</Table>
							<h4>Customers Purchase Pattrens and Loyalty Points</h4>
							<>
								{customerData.length > 0 ? (
									customerData.map((customer) => (
										<div key={customer.customer_id}>
											<h5>Customer ID: {customer.customer_id}</h5>
											<h5>Total Points: {customer.total_points}</h5>
											<Button
												onClick={() => toggleHistory(customer.customer_id)}
											>
												{showHistory[customer.customer_id]
													? 'Hide Purchase History'
													: 'Show Purchase History'}
											</Button>
											{showHistory[customer.customer_id] && (
												<Table striped bordered hover>
													<thead>
														<tr>
															<th>Order ID</th>
															<th>Title</th>
															<th>Total</th>
															<th>Payment State</th>
															<th>Created Time</th>
														</tr>
													</thead>
													<tbody>
														{customer.purchase_history.map((order) => (
															<tr key={order.id}>
																<td>{order.id}</td>
																<td>{order.title}</td>
																<td>{formatPrice(order.total)}</td>
																<td>{order.paymentState}</td>
																<td>
																	{new Date(order.createdTime).toLocaleString()}
																</td>
															</tr>
														))}
													</tbody>
												</Table>
											)}
											<br />
										</div>
									))
								) : (
									<p>No customer data found</p>
								)}
							</>
						</>
					)}
				</div>
			</div>
		</div>
	)
}

export default Analytics
